import { useQuery } from '@tanstack/react-query';
import { fetchGroup } from '../../../api';

export function useGroupQuery(groupId: string) {
  return useQuery({
    queryKey: ['group', groupId],
    queryFn: () => fetchGroup(groupId),
  });
}
